<template>
  <div id="page-product-details">
    <commercial-product-form
        v-model="model"
        :loading="loading"
        ref="form"
        @add-dynamic-product="addDynamicProduct"
        card-title="Edit"
    />
    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              @click="$router.push({ name: 'commercial-products.view', params: { id } })"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              @click="save"
              class="my-4"
              color="light"
              :disabled="!model.id"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import CommercialProductForm from "@/views/pages/commercial-products/CommercialProductForm";
import ViewModelMixin from "@/components/mixins/ViewModelMixin";
import NotificationMixin from "@/components/mixins/NotificationMixin";
import SaveModelMixin from '@/components/mixins/SaveModelMixin';

export default {
  name: "CommercialProductEdit",
  components: {
    CommercialProductForm,
  },
  mixins: [ViewModelMixin,NotificationMixin,SaveModelMixin],
  data() {
    return {
      modelEntity: this.$api.commercialProducts,
      entity: 'Commercial Product',
      references: [
        'Product_FK',
        'ProductCategory_RiskCode_FK',
        'ProductCategory_SubRiskCode_FK',
        'ClaimNotification_FK',
        'ParentCommercialProduct_FK',
        'SalesCountryType_FK',
      ],
    };
  },
  computed: {
    title() {
      if (!this.model.CommercialProductName) {
        return '';
      }

      const name = this.model.CommercialProductName  || '';
      return '<h1>Commercial Product: ' + name + '</h1>';
    }
  },
  methods: {
    addDynamicProduct(value) {
      this.references.push(value);
    },
  },
};
</script>

<style scoped>

</style>
